export default __webpack_public_path__ + "static/media/spin2.96fd105a.png";